import { Loader } from '@googlemaps/js-api-loader';

export default async function loadGMapAPI() {
  return new Promise((resolve) => {
    if (!window.GMAP_API_IS_LOADED) {
      const loader = new Loader({
        apiKey: 'AIzaSyBAfmAnEzktoU9jz3XBE2w68zEaEdmkjlE',
        version: 'weekly',
        libraries: ['places'],
      });

      loader.load()
        .then(() => {
          window.GMAP_API_IS_LOADED = true;
          resolve();
        });
    } else {
      resolve();
    }
  });
}
